import { render } from "./CruAks.vue?vue&type=template&id=3954cd64&scoped=true&ts=true"
import script from "./CruAks.vue?vue&type=script&lang=ts"
export * from "./CruAks.vue?vue&type=script&lang=ts"

import "./CruAks.vue?vue&type=style&index=0&id=3954cd64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3954cd64"]])

export default __exports__